export default "__VITE_ASSET__7jCrURIS__"